import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

import { useApi } from "@/lib/api";

interface AssetRow {
  id: string;
  filename: string | null;
  metadata_json: string;
}

export function ArticleCard(props: { asset_id: string }) {
  const api = useApi();
  const [asset, setAsset] = useState<AssetRow | null>(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    api<{ asset: AssetRow }>(`/api/assets/${props.asset_id}`).then((r) => setAsset(r.asset));
  }, [props.asset_id, api]);

  if (!asset) {
    return (
      <div className="rounded-2xl border border-neutral-200 bg-white p-3 text-sm text-neutral-400">
        Loading…
      </div>
    );
  }

  let meta: { content_md?: string; title?: string } = {};
  try {
    meta = JSON.parse(asset.metadata_json) as typeof meta;
  } catch {
    //
  }
  const md = meta.content_md ?? "";
  const title = meta.title ?? asset.filename ?? "Article";

  return (
    <div className="rounded-2xl border border-neutral-200 bg-white p-4">
      <div className="mb-2 flex items-baseline justify-between">
        <div className="text-sm font-semibold">📖 {title}</div>
        <button
          onClick={() => setExpanded((e) => !e)}
          className="text-xs text-neutral-500 hover:text-neutral-900"
        >
          {expanded ? "Collapse" : "Expand"}
        </button>
      </div>
      {expanded ? (
        <div className="prose prose-sm max-w-none">
          <ReactMarkdown>{md}</ReactMarkdown>
        </div>
      ) : (
        <p className="line-clamp-3 text-xs text-neutral-500">{md.slice(0, 200)}</p>
      )}
    </div>
  );
}
